import axios from 'axios'
import { ElMessage } from 'element-plus'
import { PageType } from '@/globalcfg'

const pageType = PageType;

let timeout = 38000;
if(pageType === "ContentMaker")
{
    timeout = 240000; // 内容制作页面，允许更长的超时时间
}
else
{
    timeout = 60000; // 官网页面，保持较短的超时时间
}

// 创建axios实例
const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || '';

const service = axios.create({
    baseURL: API_BASE_URL,
    timeout: timeout
})

service.interceptors.request.use(config => {
    return config;
});

// 响应拦截器
service.interceptors.response.use(res => {
    //后台正常返回
    // console.dir(res.data)
    var msg=undefined;
    const payload = res.data;
    const hasCodeField = payload && Object.prototype.hasOwnProperty.call(payload, 'code');
    const code = hasCodeField ? payload.code : undefined;
    if(code==403||code==405)
    {
        msg="Network error, please try again later！";
    }
    else if(code==410||code==412||code==413){
        msg="Please upload two single photos！";
    }
    if (msg) {
        ElMessage({
            message: msg,
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject('error')
    }
    if (hasCodeField) {
        return payload;
    }
    return payload;
},
    error => {
        console.error('err' + error)
        let { message } = error;
        if (message == "Network Error") {
            message = "Network Error";
        }
        else if (message.includes("timeout")) {
            message = "Request Timeout";
        }
        else if (message.includes("Request failed with status code")) {
            message = message.substr(message.length - 3);
        }
        ElMessage({
            message: message,
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error)
    }
)


//发送post请求
export function post (url, data) {
    return service({
        url: url,
        method: 'post',
        data: data
    })
}

// 发送json格式的post请求
export function post_Json (url, data) {
    return service({
        url: url,
        method: 'post',
        data:  JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

// 发送json格式的elk 统计信息
export function post_Json_elk_statistic(data){
    let stat_url = '/imageprocesshost' + '/statistic';
    post_Json(stat_url, data).then(
        (res) => {
            // 不做任何事情
        });
}

//发送get请求
export function get(url, params = {}, config = {})
{
    return service({
        url,
        method: 'get',
        params,
        ...config
    })
}

